module.exports = __webpack_public_path__ + "img/monitor.1b2ef697.png";